import { Controller } from "@hotwired/stimulus"

const HEX = /^#[0-9a-f]{6}$/i
const OWN_IMAGE_PATH = "/media/"

// Live preview of the deck back and face next to the deck form. Listens to every input in the form;
// the server validates the same fields again on save.
export default class extends Controller {
  static targets = ["title", "color", "backImage", "faceIcon"]

  connect() {
    this.render()
  }

  render() {
    const color = this.colorTarget.value.trim()
    const title = this.titleTarget.value.trim() || "Название колоды"
    this.element.querySelectorAll(".deck-preview .game-card").forEach((card) => {
      if (HEX.test(color)) card.style.setProperty("--ct-deck-back", color)
      card.querySelectorAll(".game-card__deck-title").forEach((node) => { node.textContent = title })
      this.showImage(card.querySelector(".game-card__back-image"), this.backImageTarget.value)
      this.showImage(card.querySelector(".game-card__icon"), this.faceIconTarget.value)
    })
  }

  showImage(img, value) {
    const url = value.trim()
    let own = false
    try {
      const parsed = new URL(url, window.location.href)
      own = parsed.origin === window.location.origin && parsed.pathname.startsWith(OWN_IMAGE_PATH)
    } catch (_) { own = false }
    if (url && own) {
      img.src = url
      img.hidden = false
    } else {
      img.removeAttribute("src")
      img.hidden = true
    }
  }
}
